// --- React
import React from 'react';
// --- UI Components
import Button from '@dtci/spellbook/Button';

/**
 * IconCellRenderer Component
 *
 * This component is a cell renderer for AG Grid that renders an icon (non-button).
 *
 * @returns {JSX.Element} The rendered button component.
 **/
export const IconCellRenderer = () => {
    const Renderer = ({ data }) => {
        if (data.clearanceMemoImported || data.isPublic) {
            return <i className="fa-regular fa-circle-check" style={{ color: '#3611c8' }}></i>;
        } else {
            return <i className="fa-regular fa-circle-x" style={{ color: '#d40909' }}></i>;
        }
    };

    return Renderer;
};
